import Honeybadger from "honeybadger-js";
import hyperHTML from "hyperhtml";
import escapeStringRegexp from "escape-string-regexp";
export const validFilename = require("valid-filename");

export function formatBytes(a, b) {
  if (0 == a) return "0 Bytes";
  let c = 1024,
    d = b || 2,
    e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}

export async function loadAsyncJS(url, attr, callback) {
  let script;
  if (attr && attr.id && document.querySelector('script[id="' + attr.id + '"]')) {
    return typeof callback == "function" ? callback() : false;
  }
  script = document.createElement("script");
  script.type = "application/javascript";
  if (attr) {
    Object.entries(attr).map(attr => {
      script.setAttribute(attr[0], attr[1]);
    });
  }
  let response = await fetch(url, {
    mode: "cors"
  });
  let scriptContent = await response.text();
  script.innerHTML = await scriptContent;
  $("body").append(script);
  typeof callback == "function" ? Promise.resolve(scriptContent).then(callback) : false;
  return Promise.resolve(scriptContent);
}

export const scaleNumbers = (input, set1, set2) => {
  let xMax = set2.max;
  let xMin = set2.min;
  let yMax = set1.max;
  let yMin = set2.min;
  // calculate porportion
  let percent = (input - yMin) / (yMax - yMin);
  // final scaled number
  let output = percent * (xMax - xMin) + xMin;
  return output;
};

/**
 * @function getImageNaturalSize
 * @param  {String} src the url for the image
 * @return {Promise} an object that contains the width and the height of the image in pixels value
 * {
 *  width: 200,
 *  height: 200
 * }
 */
export function getImageNaturalSize(src) {
  return new Promise(resolve => {
    let img = new Image();
    img.src = src;
    img.onload = () =>
      resolve({
        width: img.width,
        height: img.height,
        blob: new Blob([img], { type: "image/jpeg" }),
        element: img
      });
  });
}

export const GlobalRender = () => hyperHTML.bind(document.querySelector(".editor-wrapper"))`<div></div>`;

export const HB = Honeybadger.configure({
  apiKey: "8e05bbce",
  environment: "production"
});

export const getFolderNameSuggestion = node => {
  try {
    let new_name = "untitled_folder";
    if (!node?.children) return new_name;
    const untitled_folders = node.children?.filter(
      ({ title, folder }) => folder && title.replace(/_\d+$/, "") === new_name
    );
    if (untitled_folders.length) new_name += `_${untitled_folders.length}`;
    return new_name;
  } catch (e) {
    console.log(e);
  }
};

export const validInput = input => !(input?.length === 0 || input?.replace(/ /g, "").length === 0);

export const composeMatchedLines = (raw_body, query, isCaseSensitive) => {
  let lines = raw_body.split("\n").map((raw_body, idx) => ({ line_number: idx + 1, raw_body }));
  let matchedLines = lines.filter(({ raw_body }) => {
    if (!isCaseSensitive) raw_body = raw_body.toLowerCase();
    return raw_body.includes(query);
  });
  return { lines, matchedLines };
};

export const normalizeRowBody = (raw_body, query) => {
  const escapedString = escapeStringRegexp(query);
  const rgx = new RegExp(`(${escapedString})`, "gi");
  return raw_body.split(rgx);
};
